// extracted by mini-css-extract-plugin
module.exports = {"container":"Preview_container__3dhnn","summary":"Preview_summary__1Wnhn","cover":"Preview_cover__1iWzq","actions":"Preview_actions__3o3Gc"};